import React from "react";

export const GearstudioFaqView = () => {
    return (
        <section className="mx-auto max-w-4xl">
            <div className="gs-surface p-6 sm:p-8">
                <h1 className="gs-primary font-serif text-3xl sm:text-4xl">Gearstudio FAQ</h1>
                <p className="gs-secondary mt-3 text-sm sm:text-base">
                    Gearstudio lets you generate a design quickly, refine it, and place an order.
                </p>

                <div className="mt-8 space-y-6">
                    <article className="gs-divider-top pt-6">
                        <h2 className="gs-primary text-lg font-semibold">How do I create and edit a design?</h2>
                        <p className="gs-secondary mt-2 text-sm sm:text-base">
                            Start by creating a design from a prompt in the studio. After generation, open the design in Edit view where you can create a new version with another prompt or add your own images and position them on the product.
                        </p>
                    </article>

                    <article className="gs-divider-top pt-6">
                        <h2 className="gs-primary text-lg font-semibold">Who manufactures Gearstudio products?</h2>
                        <p className="gs-secondary mt-2 text-sm sm:text-base">
                            Gearstudio products are manufactured by CRBN. More information about CRBN is available at{" "}
                            <a
                                href="https://crbnpaintball.com"
                                target="_blank"
                                rel="noreferrer"
                                className="underline text-[color:var(--gs-accent-primary)] hover:text-[color:var(--gs-accent-hover)]"
                            >
                                crbnpaintball.com
                            </a>
                            .
                        </p>
                    </article>

                    <article className="gs-divider-top pt-6">
                        <h2 className="gs-primary text-lg font-semibold">Content policy for ordered products</h2>
                        <p className="gs-secondary mt-2 text-sm sm:text-base">
                            If an ordered product includes illegal, hateful or otherwise prohibited content, we reserve the right to cancel the order, issue a refund, and not ship the product.
                        </p>
                    </article>

                    <article className="gs-divider-top pt-6">
                        <h2 className="gs-primary text-lg font-semibold">Shipping Limitations</h2>
                        <p className="gs-secondary mt-2 text-sm sm:text-base">
                            Note: Gearstudio ordering is currently available only for shipping within the United States. Total shipping time is typically 4-5 weeks from the date of order, but may be longer during peak times or due to supply chain disruptions.
                        </p>
                    </article>
                </div>
            </div>
        </section>
    );
};
